// extracted by mini-css-extract-plugin
export default {"newMessageButton":"new-message-indicator_newMessageButton__6GXhU","newMessage":"new-message-indicator_newMessage__5ht9j"};